import axios from "axios";

export function getBalance() {
    return axios.get(
        process.env.REACT_APP_API_HOST + '/balance/',
        {
            headers: {
                'Authorization': localStorage.getItem('token'),
            }
        }
    );
}